/* eslint-disable react/no-danger */
import React from 'react';
import { bool, func, number, string } from 'prop-types';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import socialProfilePropType from '../../../prop_types/social_profiles';
import TooltipWrap from '../../TooltipWrap';
import useSocialProfile from '../../_data_sources/useSocialProfile';
import Icon from '../Icon';
import PlatformIcon from '../PlatformIcon';
import { AvatarContainer, AvatarImage, AvatarWrapper } from './styles';

function SocialProfileAvatar(props) {
  const {
    profile: profileData,
    profileId,
    size,
    showPlatform,
    onClick,
    tooltipPlacement,
  } = props;
  const socialProfile = profileId
    ? useSocialProfile(profileId)
    : { data: null };
  const profile = profileData || socialProfile.data;
  if (!profile) return null;

  let platformIconSize = 20;
  if (size !== 'lg') {
    platformIconSize = 16;
  }

  let tipText = (
    <div>
      <strong>{profile.external_name}</strong>
    </div>
  );
  if (profile.platform_key === 'twitter') {
    tipText = (
      <>
        <div>
          <strong>{profile.external_name}</strong>
        </div>
        <div>@{profile.screen_name}</div>
      </>
    );
  }
  const avatarProps = {};
  if (onClick !== null) {
    avatarProps.onClick = onClick;
  } else if (profile.profile_link.length > 0) {
    avatarProps.href = profile.profile_link;
    avatarProps.target = '_blank';
  }

  return (
    <TooltipWrap tipText={tipText} placement={tooltipPlacement}>
      <AvatarWrapper status={profile.effective_status}>
        <AvatarContainer
          role='presentation'
          size={size}
          showPlatform={showPlatform}
          hasImage={!!profile?.avatar_url}
          {...avatarProps}
        >
          {profile?.avatar_url ? (
            <AvatarImage
              style={{ backgroundImage: `url(${profile?.avatar_url})` }}
            />
          ) : (
            <Icon icon='user' size={size} color='neutral-10' />
          )}
        </AvatarContainer>
        {showPlatform && (
          <PlatformIcon type={profile.platform_key} size={platformIconSize} />
        )}
      </AvatarWrapper>
    </TooltipWrap>
  );
}

SocialProfileAvatar.defaultProps = {
  profile: null,
  profileId: null,
  size: 'lg',
  showPlatform: false,
  onClick: null,
  tooltipPlacement: 'top',
};

SocialProfileAvatar.propTypes = {
  profile: socialProfilePropType,
  profileId: number,
  size: string,
  showPlatform: bool,
  onClick: func,
  tooltipPlacement: string,
};

function SocialProfileAvatarFallback() {
  return <AvatarContainer />;
}

export default exportWithBoundary(
  SocialProfileAvatar,
  SocialProfileAvatarFallback
);
